export default "__VITE_ASSET__Dm6rf8Oi__"